import React, { Component, Fragment } from 'react'
import CircularProgress from "@material-ui/core/CircularProgress";
import './style.scss'

export default ({ className, small, line, fullScreen }) => (
  <div className={`${line ? 'loader line' : 'loader'} ${fullScreen !== false ? 'full' : ''}`}>
    <CircularProgress size={small ? 20 : 60} className='loader-item' />
  </div>
)
